import type { FontWeightName, HeadingLevel, TextSize } from '@makemydeal/dr-ui-bricks-types';

export const FONT_FAMILY = "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";

export const FONT_WEIGHT: Record<FontWeightName, number> = {
    bold: 700,
    semibold: 600,
    regular: 400
};

export const HEADING_SIZE: Record<HeadingLevel, string> = {
    1: '32px',
    2: '30px',
    3: '28px',
    4: '24px',
    5: '20px',
    6: '18px',
    7: '16px',
    8: '14px'
};

export const HEADING_ELEMENT: Record<HeadingLevel, keyof JSX.IntrinsicElements> = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6',
    7: 'h6',
    8: 'h6'
};

// UX: headings use auto line-height
export const HEADING_LINE_HEIGHT = 'normal';

export const TEXT_SIZE: Record<TextSize, string> = {
    xlarge: '20px',
    large: '18px',
    base: '16px',
    small: '14px',
    xsmall: '12px',
    xxsmall: '10px'
};

// UX: explicit px line-heights per size
export const TEXT_LINE_HEIGHT: Record<TextSize, string> = {
    xlarge: '28px',
    large: '26px',
    base: '22px',
    small: '20px',
    xsmall: '18px',
    xxsmall: '16px'
};
